var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    attrs: {
      label: _vm.label,
      outlined: "",
      light: "",
      dense: "",
      rules: _vm.rule,
      "input-class": "dense",
      "persistent-hint": "",
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v
      },
      expression: "selected",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }